<template>
	<!-- <content-head title="Home" /> -->
	<heading />
	<content class="">
		<div class="row">
			<div
				class="card custom-card bg-light col-xl-12 rounded-0 border-0 shadow"
			>
				<div class="row card-title pb-0 px-2 pt-2">
					<div class="row d-none">
						<div class="col-12 float-sm-left text-start">
							<h4 class="m-0 text-dark" style="font-family: NunitoBlack">
								<i class="nav-icon fas fa-home"></i>
								Custom Dashboards&nbsp;&nbsp;
							</h4>
						</div>
					</div>

					<div class="col-12">
						<div
							class="page-title-box d-sm-flex align-items-center justify-content-between nunito-black"
						>
							<div class="page-title-left">
								<ol class="breadcrumb m-0">
									<li class="breadcrumb-item">
										<a href="">
											<span
												class="badge rounded-pill bg-green-custom text-white font-size-15"
												>&nbsp;&nbsp;&nbsp;<i class="nav-icon fas fa-home"></i
												>&nbsp;&nbsp;Dashboard&nbsp;&nbsp;&nbsp;</span
											>
										</a>
									</li>

									<li class="active">
										&nbsp;&nbsp;Custom Dashboards&nbsp;&nbsp;
									</li>
								</ol>
							</div>
						</div>
					</div>
				</div>
				<div class="row card-body mt-0 pt-0">
					<div class="row">
						<div class="col-xl-4">
							<div class="card">
								<div class="card-body">
									<div class="row">
										<h4 class="card-title mb-4">Tours Registered</h4>
									</div>
									<div class="row" id="dashboard">
										<img src="/images/tours-registered.png" alt="" class="" />
										<!-- <canvas id="designationChart" height="150"></canvas> -->
									</div>
								</div>
							</div>
						</div>
						<!-- end col -->
						<div class="col-xl-4">
							<div class="card">
								<div class="card-body">
									<div class="row">
										<h4 class="card-title mb-4">Tours Confirmed</h4>
									</div>
									<div class="row" id="dashboard">
										<img src="/images/tours-confirmed.png" alt="" class="" />
										<!-- <canvas id="genderChart" height="150"></canvas> -->
									</div>
								</div>
							</div>
						</div>
						<!-- end col -->
						<div class="col-xl-4">
							<div class="card">
								<div class="card-body">
									<div class="row">
										<h4 class="card-title mb-4">Tours Tentative</h4>
									</div>
									<div class="row" id="dashboard">
										<img src="/images/tours-tentative.png" alt="" class="" />
										<!-- <canvas id="barChart" height="150"></canvas> -->
									</div>
								</div>
							</div>
						</div>
						<!-- end col -->
					</div>
					<div class="row">
						<div class="col-xl-12">
							<div class="card">
								<div class="card-body">
									<div class="row">
										<h4 class="card-title mb-4">Safari Calendar</h4>
									</div>
									<div class="row" id="dashboard">
										<!-- :plugins="calendarPlugins" -->
										<div class="row text-muted p-2">
											<full-calendar
												:plugins="calendarPlugins"
												:displayEventTime="false"
												:showNonCurrentDates="false"
												:weekends="false"
												:allDay="true"
												:events="events"
												:eventClassNames="addEventClass"
											/>
										</div>
										<!-- <canvas id="genderChart" height="150"></canvas> -->
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-xl-6">
							<div class="card p-2">
								<div class="row card-title">
									<h5 class="">Requisitions: Pending Approval</h5>
								</div>
								<div class="row card-body" id="dashboard">
									<table class="align-top table-wrap mb-0 table table-sm">
										<thead>
											<tr class="align-top text-dark">
												<th>#</th>
												<th>Created Date</th>
												<th>Supplier</th>
												<th>Ammount</th>
											</tr>
										</thead>
										<tbody class="text-start">
											<tr></tr>
										</tbody>
										<tfoot class="d-none"></tfoot>
									</table>
								</div>
							</div>
						</div>
						<!-- end col -->
						<div class="col-xl-6">
							<div class="card p-2">
								<div class="row card-title">
									<h5 class="">Requisitions: Pending Payment</h5>
								</div>
								<div class="row card-body" id="dashboard">
									<table class="align-top table-wrap mb-0 table table-sm">
										<thead>
											<tr class="align-top text-dark">
												<th>#</th>
												<th>Approved Date</th>
												<th>Supplier</th>
												<th>Ammount</th>
											</tr>
										</thead>
										<tbody class="text-start">
											<tr></tr>
										</tbody>
										<tfoot class="d-none"></tfoot>
									</table>
								</div>
							</div>
						</div>
						<!-- end col -->
					</div>
				</div>
			</div>
		</div>
	</content>
</template>

<script>
import Fullcalendar from "@fullcalendar/vue3";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
// import listPlugin from "@fullcalendar/list";

export default {
	components: {
		Fullcalendar,
	},
	data() {
		return {
			events: [],
			calendarOptions: {
				plugins: [dayGridPlugin, interactionPlugin],
				initialView: "dayGridMonth",
				displayEventTime: "false",
			},
			calendarPlugins: [dayGridPlugin, interactionPlugin],
			holidays: ["2024-07-04", "2024-06-17", "2024-06-26"],
			highlightedDate: "2024-05-01",
		};
	},
	computed: {},
	methods: {},
	created() {},
	beforeMount() {},
	mounted() {},
	unmounted() {},
	beforeUnmount() {},
};
</script>



